import React from "react";
import Header from "Components/Header/Header";
import Footer from "Components/Footer/Footer";
import "../FooterPage.scss";

const Contact = () => {
  return (
    <div>
      <Header />
      <div className="contactPage">
        <h1 className="h1_footerPage">Contactez-nous</h1>
        <div>
          <h3>Une question, un conseil, un problème ?</h3>
          <p>
            {" "}
            Contactez les administrateurs des plateformes Réseau Pro sur ce mail
            générique : equipereseaupro@unpidf.fr
          </p>
        </div>
      </div>{" "}
      <Footer />
    </div>
  );
};

export default Contact;
